import { EnumErrorLevel } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ValidationResult } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';

/**
 * 校验结果
 */
export class ValidationResultHelper {
  /**
   * 创建一个校验结果，如果发生错误的元素在一个容器图形中，需要设置容器，否则，设置自己作为容器，不能为空
   * @param errorLevel 错误等级
   * @param containerDesignId 容器的设计器ID，比如实体
   * @param designId 发生错误的元素的设计器ID，比如属性
   * @param message 错误消息
   * @returns 校验结果
   */
  static createResult(errorLevel: EnumErrorLevel, containerDesignId: string, designId: string, message: string): ValidationResult {
    const validationResult = new ValidationResult();
    validationResult.errorLevel = errorLevel;
    validationResult.message = message;
    validationResult.designId = designId;
    validationResult.containerDesignId = containerDesignId;
    return validationResult;
  }
}
